export default __webpack_public_path__ + "images/e0c561c69357bed740cf4d0f1573830b.svg";